import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSetRecoilState, useRecoilValue } from "recoil";
import Cookies from "js-cookie";
import axios from "axios";
import { useTheme } from "../../hooks";
import { menuState, authState } from "../recoil";
import { _TEST1234 } from "./ApiConfig";

// TODO : OGA 로 변경.
const PTL_API = process.env.REACT_APP_API_OSCI;

const OGA_FLAG = Cookies.get("oga") === "true" || _TEST1234.SYSTEM_GROUP_ORI === "tanoga" ? "/oga" : "";

const getMenuWithoutSign = async (lang: any) => {
    try {
        const url = `${PTL_API}/api/v1/${_TEST1234.PORTAL_TYPE}/comn/menu${OGA_FLAG}`;
        const { data } = await axios.get(url, { headers: { "Accept-Language": lang } });
        return data.menuDta;
    } catch (error) {
        console.log(error);
    }
};

const getMenuWithSign = async (lang: any) => {
    try {
        const url = `${PTL_API}/api/v1/${_TEST1234.PORTAL_TYPE}/comn/menu${OGA_FLAG}/lgn`;
        const authorization = _TEST1234.AUTHORIZATION;
        const { data } = await axios.get(url, {
            headers: { Authorization: "Bearer " + authorization, "Accept-Language": lang },
        });

        return data.menuDta;
    } catch (error) {
        console.log(error);
        // console.log(error);
    }
};

const MenuConfig = () => {
    const { theme } = useTheme();
    const setMenu = useSetRecoilState(menuState);
    const auth = useRecoilValue(authState);

    useEffect(() => {
        if (new URLSearchParams(location.search).get("ppup") === "Y") return;
        if (auth.isSignedIn) return;

        (async () => {
            try {
                //@ts-ignore
                const ssmc = JSON.parse(window.sessionStorage.getItem("menu-config"));
                const ssmd = window.sessionStorage.getItem("menu-nonSigned");
                let nonSigned: any;
                if (ssmd === null || ssmc?.lang !== theme.lang) {
                    nonSigned = await getMenuWithoutSign(theme.lang);
                    window.sessionStorage.setItem("menu-nonSigned", JSON.stringify(nonSigned));
                    window.sessionStorage.setItem("menu-config", JSON.stringify({ ...ssmc, lang: theme.lang }));
                }
                //@ts-ignore
                else nonSigned = JSON.parse(ssmd);

                if (typeof nonSigned !== "object") throw "error";
                setMenu((prev) => ({ ...prev, nonSigned }));
            } catch (error) {
                console.log(error);
                window.sessionStorage.removeItem("menu-config");
                window.sessionStorage.removeItem("menu-nonSigned");
            }
        })();
    }, [theme.lang, auth.isSignedIn]);

    useEffect(() => {
        if (new URLSearchParams(location.search).get("ppup") === "Y") return;
        if (!auth.isSignedIn) return;

        (async () => {
            try {
                //@ts-ignore
                const ssmc = JSON.parse(window.sessionStorage.getItem("menu-config"));
                const ssmd = window.sessionStorage.getItem("menu-signed");
                let signed: any;
                if (ssmd === null || ssmc?.lang !== theme.lang || ssmc?.co !== auth.userInfo.coDclaCd) {
                    signed = await getMenuWithSign(theme.lang);
                    window.sessionStorage.setItem("menu-signed", JSON.stringify(signed));
                    window.sessionStorage.setItem(
                        "menu-config",
                        JSON.stringify({ ...ssmc, lang: theme.lang, co: auth.userInfo.coDclaCd }),
                    );
                }
                //@ts-ignore
                else signed = JSON.parse(ssmd);

                if (typeof signed !== "object") throw "error";
                setMenu((prev) => ({ ...prev, signed }));
            } catch (error) {
                // console.log(error);
                window.sessionStorage.removeItem("menu-config");
                window.sessionStorage.removeItem("menu-signed");
            }
        })();
    }, [theme.lang, auth.isSignedIn, auth.userInfo.coDclaCd]);

    return null;
};

const _map = (obj: any, ary: any, _parents: any = {}) => {
    ary.forEach((_: any) => {
        obj[_["menuId"]] = { ..._, _parents };
        if (Array.isArray(_.children)) {
            _map(obj, _.children, { ..._parents, [_["menuLvl"]]: _["menuId"] });
        }
    });
};

const useMenu = () => {
    useLocation();
    const { signed, nonSigned } = useRecoilValue(menuState);
    const { isSignedIn } = useRecoilValue(authState);
    const { t } = useTranslation();

    const url = new URL(window.location.href);
    const menuId = url.searchParams.get("menuId") || "";
    const contextPath = window.location.pathname.split("/")[1];

    const root = isSignedIn ? signed : nonSigned;

    let title = "",
        system = "",
        part = {},
        current: any = {},
        data: any = {};

    block: if (true) {
        switch (menuId) {
            case "mytodo":
                title = t("T_MY_TODO");
                break block;
            case "elecTemp":
                title = t("T_ELCT_DCLR_TEMP_SAVE");
                break block;
            case "elecPrcss":
                title = t("T_ELCT_DCLR_PRCSS_STAT");
                break block;
            case "elecAprv":
                break block;
        }

        part =
            root?.children.find(({ bsopClsfCd, ptlTpCd }: any) => {
                let sys = bsopClsfCd;
                const _ = sys.toLowerCase();
                return contextPath.startsWith(_);
            }) || {};

        try {
            let obj: any = {};
            _map(obj, root.children);
            current = obj[menuId] || {};
            system = ((current.bsopClsfCd || "") + (current.ptlTpCd || "")).toLowerCase();
            data = current.menuLvl === 2 ? current : obj[current["_parents"][2]];
            title = data.menuNm;
        } catch (error) {}
    }

    if (!system) system = contextPath;

    return { root, title, current, data, system };
};

export { useMenu };

export default MenuConfig;
